module.exports = __webpack_public_path__ + "static/img/diseasesencyclopedia_icon_disease@2x.7804df6d.png";